// В.2.e-1: Нетраннер Химеры (liv_netranner_himery, epic, 3/3/6).
// Триггер «когда этот юнит атакует»: за каждый нанесённый урон цели —
// +1 ХП Герою владельца через healUnit.
//
// Срабатывает на:
//   - Авто-атаки в Ф3 (forward в unitVsUnit / unitVsHero).
//   - Контратаки (backward в unitVsUnit, когда Химера сама — defender).
//   - Стелс-активацию в Ф4/Ф5 (она тоже идёт через unitVsUnit / unitVsHero).
//   - Каждую атаку Frenzy (обе атаки за Ф3 — отдельные unitVsUnit вызовы).
//
// damageDealt = armorAbsorbed + hpLost (БЕЗ immuneAbsorbed). Если цель
// поглотила всё Иммунитетом — damageDealt=0, healUnit вернёт actualAmount=0,
// событие healed не эмитится. Это норма.
//
// Молчание Химеры блокирует триггер (см. fireOnAttackTrigger в
// on-attack-triggers.js).

import { registerOnAttackTrigger } from './on-attack-triggers.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_netranner_himery';
const LABEL = 'Нетраннер Химеры';

registerImplementedAbility(CARD_ID, 'trigger');

// В.2.i-fix1: nullsafe относительно state на случай, если триггер вдруг
// вызовут без state (для on_attack этого пока не наблюдалось — combat.js
// всегда прокидывает state, — но превентивно по аудиту вместе с Альфой).
registerOnAttackTrigger(CARD_ID, (state, attacker, target, damageDealt) => {
  if (damageDealt <= 0) return;
  const ownerIdx = attacker.ownerId;
  if (ownerIdx == null) return;
  const owner = state?.players?.[ownerIdx];
  if (!owner?.hero) return;
  state?.log?.add?.(
    `🩸 ${LABEL} [${owner.name}]: атака нанесла ${damageDealt} урона → +${damageDealt} ХП Герою`
  );
  healUnit(state, owner.hero, damageDealt, attacker);
});
